<template>
  <aside
    :class="[
      'bg-gradient-to-b from-slate-900 via-[#1B2F40] to-slate-900 text-slate-300 w-64 min-h-screen z-40 transition-all duration-300 ease-in-out shadow-2xl',
      isOpen ? 'ml-0' : '-ml-64',
      'fixed left-0 top-0 overflow-y-auto custom-scrollbar'
    ]"
  >
    <div class="sticky top-0 bg-slate-900/80 backdrop-blur-md p-6 border-b border-white/5 z-10">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg bg-gradient-to-tr from-blue-500 to-cyan-400 flex items-center justify-center shadow-lg shadow-blue-500/30">
          <span class="text-white font-bold text-lg leading-none">L</span>
        </div>
        <span class="text-xl font-extrabold text-white tracking-wide">Lottobox</span>
      </div>
    </div>

    <div class="p-4">
      <ul class="space-y-1.5">
        <li>
          <NuxtLink to="/agent/dashboard" class="menu-link">
            <Gauge class="w-5 h-5" /> {{ $t('sidebar.dashboard') }}
          </NuxtLink>
        </li>
        
        <li class="pt-4">
          <div class="px-4 py-2 text-xs font-bold uppercase tracking-wider text-slate-500">
            {{ $t('sidebar.account') }}
          </div>
          <ul class="mt-1 space-y-1 border-l border-slate-700/50 ml-6 pl-2">
            <li>
              <NuxtLink to="/agent/players" class="sub-menu-link">
                <Users class="w-4 h-4" /> {{ $t('sidebar.player_management') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/agents" class="sub-menu-link">
                <UserCog class="w-4 h-4" /> {{ $t('sidebar.agent_management') }}
              </NuxtLink>
            </li>
          </ul>
        </li>

        <li class="pt-4">
          <div class="px-4 py-2 text-xs font-bold uppercase tracking-wider text-slate-500">
            {{ $t('sidebar.report') }}
          </div>
          <ul class="mt-1 space-y-1 border-l border-slate-700/50 ml-6 pl-2">
            <li>
              <NuxtLink to="/agent/report/weekly_profit" class="sub-menu-link">
                <BarChart class="w-4 h-4" /> {{ $t('sidebar.reports.weekly_profit') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/report/groupstrike" class="sub-menu-link">
                <ShieldCheck class="w-4 h-4" /> {{ $t('sidebar.reports.group_strike') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/report/group-sales" class="sub-menu-link">
                <LineChart class="w-4 h-4" /> {{ $t('sidebar.reports.group_sales') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/report/wallet-index" class="sub-menu-link">
                <Wallet class="w-4 h-4" /> {{ $t('sidebar.reports.wallet_detail') }}
              </NuxtLink>
            </li>
          </ul>
        </li>

        <li class="pt-4 pb-8">
          <div class="px-4 py-2 text-xs font-bold uppercase tracking-wider text-slate-500">
            {{ $t('sidebar.settings.title') }}
          </div>
          <ul class="mt-1 space-y-1 border-l border-slate-700/50 ml-6 pl-2">
            <li>
              <NuxtLink to="/agent/reset-password" class="sub-menu-link">
                <Lock class="w-4 h-4" /> {{ $t('sidebar.settings.change_password') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/transfer" class="sub-menu-link">
                <Send class="w-4 h-4" /> {{ $t('sidebar.settings.transfer') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/agent/set-pin" class="sub-menu-link">
                <KeyRound class="w-4 h-4" /> {{ $t('sidebar.settings.set_pin') }}
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, watch } from 'vue'
import { useRoute } from 'vue-router'
import {
  Gauge, Users, UserCog, Send,
  BarChart, Wallet, ShieldCheck, LineChart, KeyRound, Lock
} from 'lucide-vue-next'

const props = defineProps<{ isOpen: boolean }>()
const emit = defineEmits<{ (e:'close'): void }>()
const route = useRoute()

watch(() => route.fullPath, () => {
  if (process.client && window.innerWidth < 1024) {
    emit('close')
  }
})
</script>

<style scoped>
.menu-link {
  @apply flex items-center gap-3 px-4 py-2.5 rounded-xl font-medium transition-all duration-200;
  @apply hover:bg-white/10 hover:text-white hover:shadow-sm;
}
.sub-menu-link {
  @apply flex items-center gap-3 px-3 py-2 text-sm rounded-lg transition-all duration-200 text-slate-400;
  @apply hover:bg-white/5 hover:text-white hover:translate-x-1;
}
.router-link-exact-active {
  @apply bg-gradient-to-r from-blue-500/20 to-transparent text-blue-400 font-semibold border-l-2 border-blue-500 rounded-l-none;
}
/* 隐藏滚动条但保留滚动功能 */
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
</style>
